import React from "react";
import "./header.css";
import LeftIcon from "../common/icons/arrows/largeLeftIcon";
import CloseMenuIcon from "../common/icons/closeMenuIcon";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    pageHeader: {
        position: "relative",
        height: "var(--app-header-height)",
        left: "0%",
        right: "0%",
        top: "0px",
        color: "var(--foreground-inverted)",
        background: "var(--blue-bell)",
    },
    pageTitle: {
        position: "absolute",
        marginTop: "17px",
        left: "56px",
        fontFamily: "Arial",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "24px",
    },
    icon: {
        position: "absolute",
        padding: "15px 16px",
        cursor: "pointer",
    },
    icon2: {
        position: "inherit",
        float: "right",
        padding: "15px 16px",
        cursor: "pointer",
    },
}));

export const PageHeader = (props) => {
    const styles = useStyles();

    return (
        <div className={styles.pageHeader}>
            <ul>
                <li className={styles.icon} onClick={props.onBack}>
                    <LeftIcon color="white" />
                </li>
                <li className={styles.pageTitle}>{props.title}</li>
                <li className={styles.icon2} onClick={props.onBack}>
                    <CloseMenuIcon color="white" title=" " />
                </li>
            </ul>
        </div>
    );
};
export default PageHeader;
